var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"loader",staticClass:"o-loader"},[_c('h1',[_vm._v("Loader")])])}
var staticRenderFns = []

export { render, staticRenderFns }